export enum TransactionType {
  EnableSync = 'EnableSync'
}
